<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('employeesWithdrawals.createAWithdrawalProcess')"
          :description="$t('employeesWithdrawals.FromHereYouCanSetUpANewStaffWithdrawalProcess')"
        />
        <indexTable
          :searchText="$t('employeesWithdrawals.SearchForAnOperation')"
          :emptyTableText="$t('employeesWithdrawals.ThereAreNoWithdrawals')"
          :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
          :buttonRole="$checkRole('employees_withdrawals_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('employeesWithdrawals.Withdraw'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'employee_id',
              title: $t('employeesWithdrawals.EmployeesName'),
              to: 'employee',
              type: 'link',
              sort: true,
              link: true
            },
            {
              column: 'safe_id',
              title: $t('employeesWithdrawals.Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('employeesWithdrawals.date'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('employeesWithdrawals.cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('employeesWithdrawals.thatsAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'notes',
              title: $t('employeesWithdrawals.note'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('employeesWithdrawals.Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'printEmployeesWithdrawal', role: true },
                {
                  name: 'edit',
                  role: $checkRole('employees_withdrawals_edit')
                },
                { name: 'file' },
                {
                  name: 'delete',
                  role: $checkRole('employees_withdrawals_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/employeesWithdrawals'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
